module.exports = __webpack_public_path__ + "static/media/ISO7010.32fb2a05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/ISO7010.svg
// module id = 68
// module chunks = 0